export const META_PIXEL_ID = '913833388236433';

const isFbqReady = () => typeof window !== 'undefined' && typeof window.fbq === 'function';

export const trackMetaPixelEvent = (eventName, payload = {}) => {
  if (!isFbqReady()) {
    return;
  }

  window.fbq('track', eventName, payload);
};

export const trackMetaPixelCustomEvent = (eventName, payload = {}) => {
  if (!isFbqReady()) {
    return;
  }

  window.fbq('trackCustom', eventName, payload);
};
